/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FinancierPaymentChannelDto = {
    id?: string;
    financierPaymentChannelId?: string;
    type?: FinancierPaymentChannelDto.type;
    status?: FinancierPaymentChannelDto.status;
    bankCode?: FinancierPaymentChannelDto.bankCode;
    accountName?: string;
    accountId?: string;
    qrCodeImageUrl?: string;
    financierId?: string;
};
export namespace FinancierPaymentChannelDto {
    export enum type {
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        PROMPT_PAY_QR = 'PROMPT_PAY_QR',
        BANK_ACCOUNT = 'BANK_ACCOUNT',
        AUTOMATIC_QR = 'AUTOMATIC_QR',
        TRUE_WALLET = 'TRUE_WALLET',
        CHILLPAY_QR = 'CHILLPAY_QR',
    }
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
    export enum bankCode {
        BBL = 'BBL',
        BAY = 'BAY',
        SCB = 'SCB',
        KBANK = 'KBANK',
        KTB = 'KTB',
        TTB = 'TTB',
    }
}

